<template>

  <t-page>

    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #default="{status}">

        <t-input v-model="form[fieldKey]" hidden/>

        <t-form-tab title="Dados Básicos">

          <b-row>

            <t-input v-model="form.expenseNumber" lpad="3" cols="3" label="Cód. Despesa" fixed/>

            <t-input v-model="form.originInvoiceCode" :add-error="error.originInvoiceCode" cols="3"
                     label="Nota Fiscal"/>


            <b-col cols="6">
              <t-input-person supplier required :status="status" :command="command" :add-error="error.supplierId"
                              v-model="form.supplierId"/>

              <t-input-person creditor required :status="status" :command="command" :add-error="error.supplierId"
                              v-model="form.supplierId"/>

            </b-col>


          </b-row>
          <b-row>

            <t-input v-model="form.expeditionStatusId" required cols="4" :options="typeExpeditionStatusOptions" select
                     first-default
                     label="Status Expedição"/>

            <t-input v-model="form.companyId"
                     :options="companyOptions"
                     cols="4" required
                     label="Empresa" select/>

            <t-input v-model="form.issueDate" required cols="4" date date-now label="Data de Emissão"/>

          </b-row>


          <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

          <t-input-status v-model="form.status" class="mb-2"/>

        </t-form-tab>

      </template>

      <template #out-of-form>

        <t-form-tab title="Produtos" hash="product"
                    :disabled="!relationAccessPageGeneral('stock-expedition-order-product')" lazy>
          <ExpeditionOrderItem :foreign-key="form.expenseId"/>
        </t-form-tab>

      </template>

    </t-page-form>

  </t-page>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import ExpeditionOrderItem from "@/views/modules/stock/ExpeditionOrderProduct";
import http from "@/services/config/http-common";
import ui from "@/assets/scripts/ui";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'ExpenseForm',
  components: {ExpeditionOrderItem},
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      fieldKey: "expenseId",
      form: {
        expenseId: 0,
        expenseNumber: 0,
        companyId: 0,
        customerId: 0,
        expeditionStatusId: 0,
        issueDate: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        originInvoiceCode: "",
        customerId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      typeExpeditionStatusOptions: [],
      companyOptions: [],
      printItemsOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      await http.list(this.path + "/selectRelationList").then((response) => {
        this.typeExpeditionStatusOptions = response.typeExpeditionStatusOptions
        this.companyOptions = response.companyOptions
      }).catch(error => this.responseError(error))


      this.pageFormIsLoaded = true


    },
    async onSubmit() {

      await http.count("stock/expedition-order-product", this.form.expenseId).then(async (count) => {

        if (count > 0) {
          await this.setSendingDefault()
        } else {
          ui.msgError(this, "Insira pelo menos 1 produto para gravar a Despesa");
        }

      }).catch(error => this.responseError(error))

      //

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>